'use es6';

import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import StoredContentContainer from '../../containers/StoredContentContainer';
import { LearningContentContainer } from '../../features/learningContent';
import LessonInfoTabs from '../LessonPage/LessonInfoTabs';
import { SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS } from '../../constants/Navigation';
import { OptionalToolRecommendationSection } from '../../features/toolRecommendations';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TrackPage = ({
  track,
  onAdvanceContent,
  lesson,
  contentId
}) => {
  const indexOfLessonInTrackLessons = track && track.get('lessonIds').indexOf(lesson.get('id'));
  const nextLessonId = track && track.get('lessonIds').get(indexOfLessonInTrackLessons + 1);
  if (contentId === SOFTWARE_DISCOVERY_TOOL_RECOMMENDATIONS) return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(OptionalToolRecommendationSection, {
      contentName: lesson.get('name'),
      lessonId: lesson.get('id'),
      nextLessonId: nextLessonId,
      trackId: track.get('id'),
      useCases: lesson.get('useCases')
    }), /*#__PURE__*/_jsx(LessonInfoTabs, {
      lesson: lesson,
      trackId: track.get('id')
    })]
  });
  return /*#__PURE__*/_jsxs(LearningContentContainer, {
    contentId: contentId,
    language: track.get('language'),
    lessonId: lesson.get('id'),
    trackId: track.get('id'),
    children: [/*#__PURE__*/_jsx(StoredContentContainer, {
      contentId: contentId,
      isParentGraded: lesson.get('graded'),
      isPubliclyVisible: lesson.get('visibility') === 'PUBLIC',
      language: track.get('language'),
      lessonId: lesson.get('id'),
      lessonName: lesson.get('name'),
      onFinish: onAdvanceContent,
      trackId: track.get('id'),
      trackName: track.get('name')
    }), /*#__PURE__*/_jsx(LessonInfoTabs, {
      contentId: contentId,
      lesson: lesson,
      trackId: track.get('id')
    })]
  });
};
TrackPage.propTypes = {
  contentId: PropTypes.string.isRequired,
  lesson: ImmutablePropTypes.map.isRequired,
  onAdvanceContent: PropTypes.func.isRequired,
  track: ImmutablePropTypes.map.isRequired
};
export default TrackPage;